import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// Custom components
import Notifications from './components/Notifications';

//import Password from './components/Password';
import Profile from './components/Profile';
import Addressee from './components/Addressee';
import UsersList from './components/UsersList';
import GroupsList from './components/GroupsList';
import AlertsHours from './components/AlertsHours';
import TemplateManager from './components/TemplateManager';
import AddreesseExtendend from './components/AddresseeExtended';
//import Configuration from './components/Configuration';

// Component styles
const styles = theme => ({
    root: {
        //Custom Styles AP
        backgroundColor: '#e7e7e7',
    }
});

class Settings extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            tabIndex: 0,
            props: props,
            value: 0,
            profileId: sessionStorage.getItem('profile_id'),
            listAdreesses: [1,2,5],
            listUsers: [1],
            listGroups: [1],
            listHours: [1,2,5]
        }
    }

    myCallback = (dataFromChild) => {
        
        this.setState({
            objectivesList: dataFromChild
        })
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };

    render() {
        const { classes } = this.props;
        const {value, profileId, listAdreesses, listUsers, listGroups, listHours} = this.state;
        var disabledAdreesses = true
        var disabledUsers = true
        var disabledGroups = true
        var disabledHours = true
        if(listAdreesses.includes(parseInt(profileId)) === true){
            disabledAdreesses = false
        }
        if(listUsers.includes(parseInt(profileId)) === true){
            disabledUsers = false
        }
        if(listGroups.includes(parseInt(profileId)) === true){
            disabledGroups = false
        }
        if(listHours.includes(parseInt(profileId)) === true){
            disabledHours = false
        }
        return (
            <DashboardLayout title="Administración" callbackFromParent={this.myCallback} >
                <div className={classes.root} style={{marginTop:'101px'}}>
                    <AppBar position="static"  style={{ backgroundColor: '#333333'}}>
                        <Tabs value={value} onChange={this.handleChange} aria-label="simple tabs example">
                            <Tab label="Mi perfil"  />
                            <Tab label="Contactos" disabled={disabledAdreesses}/>
                            <Tab label="Contactos extendidos" />
                            <Tab label="Usuarios" disabled={disabledUsers}/>
                            <Tab label="Grupos" disabled={disabledGroups}/>
                            <Tab label="Horarios alertas" disabled={disabledHours}/>
                            <Tab label="Menu Templates" disabled={disabledHours}/>
                        </Tabs>
                    </AppBar>
                    { value == 0 ? 
                        <Profile/>   
                    : value == 1 ?
                        <Addressee/> 
                    : value == 2 ?
                        <AddreesseExtendend/> 
                    : value == 3 ?
                        <UsersList/> 
                    : value == 4 ?
                        <GroupsList/> 
                    : value == 5 ?
                        <AlertsHours/> 
                    :  value == 6 ?
                    <TemplateManager/> 
                : null }
                </div>
            </DashboardLayout>
        );
    }
}

Settings.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Settings);
